import React from "react";

import { makeStyles } from "tss-react/mui";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import landingPageStyle from "assets/jss/xrs/views/landingPageStyle.js";
import { useSelector } from "react-redux";
import { parseHtmlWithNonce } from "utils/HtmlParserWithNonce";

const useStyles = makeStyles()(() => landingPageStyle);

export default function FooterSection(props) {
  const { classes } = useStyles();
  const footerImage = useSelector(
    (state) => state.GetSiteDetailsReducer.footerImageUrl
  );

  return (
    <div>
      <Footer
        theme="dark"
        content={
          <GridContainer className={classes.paperLeft}>
            <GridItem xs={12} sm={4} md={4}>
              <p className={classes.footerParagraph}>
                {parseHtmlWithNonce(props.AboutUs)}
              </p>
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              {parseHtmlWithNonce(props.footergridcentertext)}
            </GridItem>
            <GridItem xs={12} sm={4} md={4} className={classes.CenterAlign}>
              <br></br>
              <br></br>
              {footerImage === "" ? null : (
                <img src={footerImage} alt="..." height="150" width="220" />
              )}
            </GridItem>
          </GridContainer>
        }
      />
    </div>
  );
}
